import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/shadcn/accordion'
import { useMemo } from 'react'
import { GroupedDataAssetsData } from './types'
import { DataAssetItem } from './DataAssetItem'
import { DataAssetGroup } from './DataAssetGroup'

export function DataAssetsAccordion({ summary }: { summary: GroupedDataAssetsData }) {
  const { items } = summary
  const groupNames = useMemo(() => items.map((item) => item.groupName), [items])
  return (
    <Accordion type="multiple" className="w-full overflow-hidden rounded-lg" defaultValue={groupNames}>
      {items.map((groupItem) => (
          <AccordionItem key={groupItem.groupName} value={groupItem.groupName} className="gap-2">
            <AccordionTrigger className="first: bg-offwhite px-5 text-lg">{groupItem.groupName}</AccordionTrigger>
            <AccordionContent className="border-l p-5 pr-0">
              {groupItem.items.map((parentItem) => (
                <DataAssetGroup key={parentItem.name} name={parentItem.name}>
                  {parentItem.items.map((childItem) => (
                    <DataAssetItem
                      groupName={groupItem.groupName}
                      parentName={parentItem.name}
                      key={`${childItem.entity.id}-${childItem.data_asset.id}`}
                      item={childItem}
                    />
                  ))}
                </DataAssetGroup>
              ))}
            </AccordionContent>
          </AccordionItem>
      ))}
    </Accordion>
  )
}
